import React from 'react';
import { BulkDeleteWithConfirmButton } from 'react-admin';
import Tooltip from '@material-ui/core/Tooltip';

const BulkDeleteButton = (props) => {
  if (props.resource == "service-offering") {
    const serviceId = localStorage.getItem('ServiceId');
    if (props.selectedIds.includes(parseInt(serviceId, 10))) {
      return (
        <Tooltip title="'New Tire Installation' service cannot be deleted">
          <span data-tip="" data-tip-disable={false}>
            <BulkDeleteWithConfirmButton {...props} disabled={true} />
          </span>
        </Tooltip>)
    }
    else {
      return (<BulkDeleteWithConfirmButton {...props} />)
    }
  } else if (props.resource == "service-vehicle") {
    const vehicleCount = localStorage.getItem('vehicleCount');
    if (vehicleCount <= 1) {
      return (
        <Tooltip title="Service vehicle cannot be deleted">
          <span data-tip="" data-tip-disable={false}>
            <BulkDeleteWithConfirmButton {...props} disabled={true} />
          </span>
        </Tooltip>)
    }
    else {
      return (<BulkDeleteWithConfirmButton {...props} />)
    }
  }
  else {
    return (<BulkDeleteWithConfirmButton {...props} />)
  }
};

export default BulkDeleteButton;
